(() => {
  if (window.__msNaosQsCalloutInit) return;
  window.__msNaosQsCalloutInit = true;

  const bind = (el) => {
    if (el.__msQsBound) return;
    el.__msQsBound = true;
    const summary = el.querySelector('summary');
    if (!summary) return;

    // Ensure native toggle works; stop parent handlers from eating the click
    summary.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  };

  const scan = () => {
    document.querySelectorAll('details.naos-qs-callout').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  const mo = new MutationObserver(() => scan());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
